import React from 'react'

const Link = ({ onClick, linkName }) => <a className='cta-link' onClick={onClick}>{linkName}</a>

export default Link
